export default "__VITE_ASSET__8afa3b5f__"